import React from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogTitle,
  Button,
  Typography,
  Box,
} from '@material-ui/core';
import List from './NoBenefits/List';
import GoldenStar from '../../../../../assets/gold_star.svg';
import { useGoldenModalStyles } from './styles';

const GoldBenefitsModal = ({ ...props }) => {
  const { benefits, type, open, onClose } = props;
  const classes = useGoldenModalStyles();
  return (
    <Dialog open={open} onClose={onClose} className={classes.dialog}>
      <DialogTitle>
        <Box display="flex" alignItems="center" justifyContent="center">
          <Typography className={classes.title}>Beneficios clientes</Typography>
          <img src={GoldenStar} className={classes.image} />
        </Box>
      </DialogTitle>
      <List benefits={benefits} type={type} />
      <Button
        data-cy="buttonGoldBenefitsModal"
        variant="outlined"
        onClick={onClose}
        className={classes.button}
      >
        Cerrar
      </Button>
    </Dialog>
  );
};

GoldBenefitsModal.propTypes = {
  benefits: PropTypes.array,
  type: PropTypes.string,
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

export default GoldBenefitsModal;
